"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/styles");
var _styles2 = require("./styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AlertHeader = _ref => {
  let {
    header,
    classes
  } = _ref;
  if (header) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: classes.alertHeader
    }, header);
  }
  return null;
};
var _default = exports.default = (0, _styles.withStyles)(_styles2.useStyles)(AlertHeader);